/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { HandShakeIcon16Light } from './HandShakeIcon16Light';
import { HandShakeIcon16Regular } from './HandShakeIcon16Regular';
import { HandShakeIcon16Solid } from './HandShakeIcon16Solid';
import { HandShakeIcon20Light } from './HandShakeIcon20Light';
import { HandShakeIcon20Regular } from './HandShakeIcon20Regular';
import { HandShakeIcon20Solid } from './HandShakeIcon20Solid';
import { HandShakeIcon24Regular } from './HandShakeIcon24Regular';
import { HandShakeIcon24Solid } from './HandShakeIcon24Solid';
import { HandShakeIcon32Regular } from './HandShakeIcon32Regular';
import { HandShakeIcon64Regular } from './HandShakeIcon64Regular';
var sizes = {
    16: {
        light: HandShakeIcon16Light,
        regular: HandShakeIcon16Regular,
        solid: HandShakeIcon16Solid,
    },
    20: {
        light: HandShakeIcon20Light,
        regular: HandShakeIcon20Regular,
        solid: HandShakeIcon20Solid,
    },
    24: {
        regular: HandShakeIcon24Regular,
        solid: HandShakeIcon24Solid,
    },
    32: {
        regular: HandShakeIcon32Regular,
    },
    64: {
        regular: HandShakeIcon64Regular,
    },
};
export var HandShakeIcon = forwardRef('HandShakeIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
